export default "__VITE_ASSET__6073ed33__"